import { z } from 'zod';
import { AppointmentSchema } from '../../../appointments';

export const baseAiGeneratedResponseSchema = <T extends z.ZodType>(schema: T) =>
  z.object({
    form: schema,
    appointmentsWithTranscriptions: z.array(AppointmentSchema),
    documentsUsed: z.array(z.string()),
  });
